/**
 * Claves de `resourceCache` para las listas de flota.
 *
 * Viven en su propio módulo —y no en cada pantalla— porque son un CONTRATO
 * entre tres sitios que no se importan entre sí: la pantalla que lee, el
 * precargador del rail que calienta el dato, y la mutación que invalida. Una
 * clave escrita a mano en dos de esos tres sitios y mal en el tercero da un
 * bug mudo: la lista sigue mostrando lo viejo y nadie ve un error.
 *
 * El prefijo `fleet:` es lo que hace posible `invalidateResource("fleet:")`
 * tras una escritura con efectos cruzados (borrar un vehículo cambia la
 * columna «Vehículo» de Dispositivos, asignar un GPS cambia las dos listas).
 */
export const FLEET_PREFIX = "fleet:";

export const FLEET_KEYS = {
  vehicles: "fleet:vehicles",
  gpsDevices: "fleet:gps-devices",
  pendingDevices: "fleet:pending-devices",
  drivers: "fleet:drivers",
  simCards: "fleet:sim-cards",
  groups: "fleet:groups",
};

/**
 * Las listas que se pisan entre sí. Un vehículo borrado, un GPS asignado o una
 * SIM movida cambian lo que muestran VARIAS de estas pantallas, así que
 * cualquier escritura en Flota las marca a todas para revalidar.
 *
 * `groups` queda FUERA a propósito: es la única que no cambia por una
 * escritura de flota —solo la tocan las mutaciones de la propia pantalla de
 * Grupos, que actualizan la entrada a mano— e incluirla habría sumado una
 * petición inútil detrás de cada guardado.
 */
export const FLEET_ENTITY_KEYS = [
  FLEET_KEYS.vehicles,
  FLEET_KEYS.gpsDevices,
  FLEET_KEYS.pendingDevices,
  FLEET_KEYS.drivers,
  FLEET_KEYS.simCards,
];
